import { ValidationErrors, ValidatorFn, AbstractControl, Validators, FormGroup } from '@angular/forms';
import { formatDate } from "@angular/common";
import * as moment from 'moment';
export class CustomValidators {
    static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if (!control.value) {
                // if control is empty return no error
                return null;
            }

            // test the value of the control against the regexp supplied
            const valid = regex.test(control.value);

            // if true, return no error (no error), else return error passed in the second parameter
            return valid ? null : error;
        };
    }

    static passwordMatchValidator(control: AbstractControl) {
        const password: string = control.get('newPassword').value; // get password from our password form control
        const confirmPassword: string = control.get('confirmPassword').value; // get password from our confirmPassword form control
        // compare is the password math
        if (password !== confirmPassword) {
            // if they don't match, set an error in our confirmPassword form control
            control.get('confirmPassword').setErrors({ NoPassswordMatch: true });
        }
    }

    static passwordMatchValidatorChange(control: AbstractControl) {
        const newPassword: string = control.get('newPassword').value; // get password from our password form control
        const confirmPassword: string = control.get('confirmPassword').value; // get password from our confirmPassword form control
        // compare is the password math
        if (newPassword !== confirmPassword) {
            // if they don't match, set an error in our confirmPassword form control
            control.get('confirmPassword').setErrors({ NoPassswordMatch: true });
        }
    }

    static scoreOutOfTotal(control: AbstractControl) {
        const ihrbRides: string = control.get('ihrbRides').value;
        const ihrbWins: string = control.get('ihrbWins').value;
        if (ihrbRides >= ihrbWins) {
            control.get('ihrbWins').setErrors({ NoPassswordMatch: true });
        }
    }

    endMobileCheck(fg: FormGroup): ValidatorFn | any {
        const mobileCountryCode = fg.get('mobileCountryCode').value;
        const middleMobilePhoneNumber = fg.get('middleMobilePhoneNumber').value;
        if (mobileCountryCode === null || mobileCountryCode === '') {
            fg.get('mobileCountryCode').setErrors({ 'incorrect': true });
        } else if (mobileCountryCode === '+353') {
            fg.get('middleMobilePhoneNumber').setValidators([Validators.required]);
            if (middleMobilePhoneNumber === '083' || middleMobilePhoneNumber === '085' ||
                middleMobilePhoneNumber === '086' || middleMobilePhoneNumber === '087' || middleMobilePhoneNumber === '089') {
                fg.get('middleMobilePhoneNumber').setErrors(null);
            } else {
                fg.get('middleMobilePhoneNumber').setErrors({ 'incorrect': true });
            }
            fg.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{6}')]);
            if (fg.get('mobilePhoneNumber').value.length === 7) {
                fg.get('mobilePhoneNumber').setErrors(null);
            } else {
                fg.get('mobilePhoneNumber').setErrors({ 'incorrect': true });
            }
        } else if (mobileCountryCode === '+44') {
            fg.get('middleMobilePhoneNumber').setValidators([Validators.required]);
            if (middleMobilePhoneNumber === '073' || middleMobilePhoneNumber === '075' || middleMobilePhoneNumber === '076' ||
                middleMobilePhoneNumber === '077' || middleMobilePhoneNumber === '078' || middleMobilePhoneNumber === '079') {
                fg.get('middleMobilePhoneNumber').setErrors(null);
            } else {
                fg.get('middleMobilePhoneNumber').setErrors({ 'incorrect': true });
            }
            fg.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{7}')]);
            if (fg.get('mobilePhoneNumber').value.length === 8) {
                fg.get('mobilePhoneNumber').setErrors(null);
            } else {
                fg.get('mobilePhoneNumber').setErrors({ 'incorrect': true });
            }
        } else {
            fg.get('middleMobilePhoneNumber').setErrors(null);
            fg.get('middleMobilePhoneNumber').setValidators(null);
            fg.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{5,15}')]);
            if (fg.get('mobilePhoneNumber').value.length >= 5 && fg.get('mobilePhoneNumber').value.length <= 15) {
                fg.get('mobilePhoneNumber').setErrors(null);
            } else {
                fg.get('mobilePhoneNumber').setErrors({ 'incorrect': true });
            }
        }
        fg.get('mobileCountryCode').valueChanges.subscribe(data => {
            fg.get('middleMobilePhoneNumber').setValue('');
        });
    }

    endDateCheck(fg: FormGroup): ValidatorFn | any {
        const first = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        const second = fg.get('dateOfBirth');
        if (second.value === null) {
            return null;
        }
        const date1 = moment(first);
        const date2 = moment(second.value);
        const diff1 = moment(date1).diff(date2, 'days');
        if (diff1 <= -1) {
            return {
                'invalidDate': true
            };
        } else {
            if (fg.hasError('invalidDate') || fg.hasError('notFullWeek')) {
                return null;
            }
        }


        const mobileCountryCode = fg.get('mobileCountryCode').value;
        const middleMobilePhoneNumber = fg.get('middleMobilePhoneNumber').value;
        if (mobileCountryCode === null || mobileCountryCode === '') {
            fg.get('mobileCountryCode').setErrors({ 'incorrect': true });
        } else if (mobileCountryCode === '+353') {
            fg.get('middleMobilePhoneNumber').setValidators([Validators.required]);
            if (middleMobilePhoneNumber === '083' || middleMobilePhoneNumber === '085' ||
                middleMobilePhoneNumber === '086' || middleMobilePhoneNumber === '087' || middleMobilePhoneNumber === '089') {
                fg.get('middleMobilePhoneNumber').setErrors(null);
            } else {
                fg.get('middleMobilePhoneNumber').setErrors({ 'incorrect': true });
            }
            fg.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{6}')]);
            if (fg.get('mobilePhoneNumber').value.length === 7) {
                fg.get('mobilePhoneNumber').setErrors(null);
            } else {
                fg.get('mobilePhoneNumber').setErrors({ 'incorrect': true });
            }
        } else if (mobileCountryCode === '+44') {
            fg.get('middleMobilePhoneNumber').setValidators([Validators.required]);
            if (middleMobilePhoneNumber === '073' || middleMobilePhoneNumber === '075' || middleMobilePhoneNumber === '076' ||
                middleMobilePhoneNumber === '077' || middleMobilePhoneNumber === '078' || middleMobilePhoneNumber === '079') {
                fg.get('middleMobilePhoneNumber').setErrors(null);
            } else {
                fg.get('middleMobilePhoneNumber').setErrors({ 'incorrect': true });
            }
            fg.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{7}')]);
            if (fg.get('mobilePhoneNumber').value.length === 8) {
                fg.get('mobilePhoneNumber').setErrors(null);
            } else {
                fg.get('mobilePhoneNumber').setErrors({ 'incorrect': true });
            }
        } else {
            fg.get('middleMobilePhoneNumber').setErrors(null);
            fg.get('middleMobilePhoneNumber').setValidators(null);
            fg.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{5,15}')]);
            if (fg.get('mobilePhoneNumber').value.length >= 5 && fg.get('mobilePhoneNumber').value.length <= 15) {
                fg.get('mobilePhoneNumber').setErrors(null);
            } else {
                fg.get('mobilePhoneNumber').setErrors({ 'incorrect': true });
            }
        }
        fg.get('mobileCountryCode').valueChanges.subscribe(data => {
            fg.get('middleMobilePhoneNumber').setValue('');
        });

        const phoneCountryCode = fg.get('phoneCountryCode').value;
        const middlePhoneNumber = fg.get('middlePhoneNumber').value;
        const phoneNumber = fg.get('phoneNumber').value;
        if ((phoneCountryCode === null || phoneCountryCode === '') && (middlePhoneNumber === null || middlePhoneNumber === '') && (phoneNumber === null || phoneNumber === '')) {
            fg.get('phoneCountryCode').setErrors(null);
            fg.get('phoneCountryCode').setValidators(null);
            fg.get('middlePhoneNumber').setErrors(null);
            fg.get('middlePhoneNumber').setValidators([Validators.pattern('^0[0-9]{1,3}')]);
            fg.get('phoneNumber').setErrors(null);
            fg.get('phoneNumber').setValidators([Validators.pattern('[0-9]\\d{5,15}')]);
        } else {
            fg.get('phoneCountryCode').setValidators([Validators.required]);
            if (phoneCountryCode === '' || phoneCountryCode === null) {
                fg.get('phoneCountryCode').setErrors({ 'incorrect': true });
            } else {
                fg.get('phoneCountryCode').setErrors(null);
            }

            fg.get('middlePhoneNumber').setValidators([Validators.required, Validators.pattern('^0[0-9]{1,3}')]);
            if (middlePhoneNumber === '' || middlePhoneNumber === null) {
                fg.get('middlePhoneNumber').setErrors({ 'incorrect': true });
            } else if (middlePhoneNumber.length <= 4) {
                fg.get('middlePhoneNumber').hasError('pattern');
            } else {
                fg.get('middlePhoneNumber').setErrors({ 'incorrect': true });
            }

            if (phoneCountryCode === '' || phoneCountryCode === null) {
                fg.get('phoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{5,15}')]);
                if (fg.get('phoneNumber').value === null) {
                    fg.get('phoneNumber').setErrors({ 'incorrect': true });
                } else if (fg.get('phoneNumber').value.length <= 15 && fg.get('phoneNumber').value.length > 4) {
                    fg.get('phoneNumber').setErrors(null);
                } else {
                    fg.get('phoneNumber').setErrors({ 'incorrect': true });
                }
            } else if (phoneCountryCode === '+353') {
                fg.get('phoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{5,15}')]);
                if (fg.get('phoneNumber').value === null) {
                    fg.get('phoneNumber').setErrors({ 'incorrect': true });
                } else if (fg.get('phoneNumber').value.length <= 15 && fg.get('phoneNumber').value.length > 4) {
                    fg.get('phoneNumber').setErrors(null);
                } else {
                    fg.get('phoneNumber').setErrors({ 'incorrect': true });
                }
            } else if (phoneCountryCode === '+44') {
                fg.get('phoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{5,15}')]);
                if (fg.get('phoneNumber').value === null) {
                    fg.get('phoneNumber').setErrors({ 'incorrect': true });
                } else if (fg.get('phoneNumber').value.length <= 15 && fg.get('phoneNumber').value.length > 4) {
                    fg.get('phoneNumber').setErrors(null);
                } else {
                    fg.get('phoneNumber').setErrors({ 'incorrect': true });
                }
            } else if (phoneCountryCode === 'Other') {
                fg.get('phoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{5,15}')]);
                if (fg.get('phoneNumber').value === null) {
                    fg.get('phoneNumber').setErrors({ 'incorrect': true });
                } else if (fg.get('phoneNumber').value.length >= 6 && fg.get('phoneNumber').value.length <= 20) {
                    fg.get('phoneNumber').setErrors(null);
                } else {
                    fg.get('phoneNumber').setErrors({ 'incorrect': true });
                }
            }
        }
    }

    nokValidation(fg: FormGroup): ValidatorFn | any {
        const nokPhoneCode = fg.get('application').get('nokPhoneCode').value;
        const middleNokPhone = fg.get('application').get('middleNokPhone').value;
        if (nokPhoneCode === null || nokPhoneCode === '') {
            fg.get('application').get('nokPhoneCode').setErrors({ 'incorrect': true });
        } else if (nokPhoneCode === '+353') {
            fg.get('application').get('middleNokPhone').setValidators([Validators.required]);
            if (middleNokPhone === '083' || middleNokPhone === '085' ||
                middleNokPhone === '086' || middleNokPhone === '087' || middleNokPhone === '089') {
                fg.get('application').get('middleNokPhone').setErrors(null);
            } else {
                fg.get('application').get('middleNokPhone').setErrors({ 'incorrect': true });
            }
            fg.get('application').get('nokPhone').setValidators([Validators.required, Validators.pattern('[0-9]\\d{6}')]);
            if (fg.get('application').get('nokPhone').value.length === 7) {
                fg.get('application').get('nokPhone').setErrors(null);
            } else {
                fg.get('application').get('nokPhone').setErrors({ 'incorrect': true });
            }
        } else if (nokPhoneCode === '+44') {
            fg.get('application').get('middleNokPhone').setValidators([Validators.required]);
            if (middleNokPhone === '073' || middleNokPhone === '075' || middleNokPhone === '076' ||
                middleNokPhone === '077' || middleNokPhone === '078' || middleNokPhone === '079') {
                fg.get('application').get('middleNokPhone').setErrors(null);
            } else {
                fg.get('application').get('middleNokPhone').setErrors({ 'incorrect': true });
            }
            fg.get('application').get('nokPhone').setValidators([Validators.required, Validators.pattern('[0-9]\\d{6}')]);
            if (fg.get('application').get('nokPhone').value.length === 8) {
                fg.get('application').get('nokPhone').setErrors(null);
            } else {
                fg.get('application').get('nokPhone').setErrors({ 'incorrect': true });
            }
        } else {
            fg.get('application').get('middleNokPhone').setErrors(null);
            fg.get('application').get('middleNokPhone').setValidators(null);
            fg.get('application').get('nokPhone').setValidators([Validators.required, Validators.pattern('[0-9]\\d{5,15}')]);
            if (fg.get('application').get('nokPhone').value.length >= 5 && fg.get('application').get('nokPhone').value.length <= 15) {
                fg.get('application').get('nokPhone').setErrors(null);
            } else {
                fg.get('application').get('nokPhone').setErrors({ 'incorrect': true });
            }
        }
        fg.get('application').get('nokPhoneCode').valueChanges.subscribe(data => {
            fg.get('application').get('middleNokPhone').setValue('');
        });
    }

    nokValidationForAgentValet(fg: FormGroup): ValidatorFn | any {
        const nokPhoneCode = fg.get('person').get('application').get('nokPhoneCode').value;
        const middleNokPhone = fg.get('person').get('application').get('middleNokPhone').value;
        if (nokPhoneCode === null || nokPhoneCode === '') {
            fg.get('person').get('application').get('nokPhoneCode').setErrors({ 'incorrect': true });
        } else if (nokPhoneCode === '+353') {
            fg.get('person').get('application').get('middleNokPhone').setValidators([Validators.required]);
            if (middleNokPhone === '083' || middleNokPhone === '085' ||
                middleNokPhone === '086' || middleNokPhone === '087' || middleNokPhone === '089') {
                fg.get('person').get('application').get('middleNokPhone').setErrors(null);
            } else {
                fg.get('person').get('application').get('middleNokPhone').setErrors({ 'incorrect': true });
            }
            fg.get('person').get('application').get('nokPhone').setValidators([Validators.required, Validators.pattern('[0-9]\\d{6}')]);
            if (fg.get('person').get('application').get('nokPhone').value.length == 7) {
                fg.get('person').get('application').get('nokPhone').setErrors(null);
            } else {
                fg.get('person').get('application').get('nokPhone').setErrors({ 'incorrect': true });
            }
        } else if (nokPhoneCode === '+44') {
            fg.get('person').get('application').get('middleNokPhone').setValidators([Validators.required]);
            if (middleNokPhone === '073' || middleNokPhone === '075' || middleNokPhone === '076' ||
                middleNokPhone === '077' || middleNokPhone === '078' || middleNokPhone === '079') {
                fg.get('person').get('application').get('middleNokPhone').setErrors(null);
            } else {
                fg.get('person').get('application').get('middleNokPhone').setErrors({ 'incorrect': true });
            }
            fg.get('person').get('application').get('nokPhone').setValidators([Validators.required, Validators.pattern('[0-9]\\d{6}')]);
            if (fg.get('person').get('application').get('nokPhone').value.length === 8) {
                fg.get('person').get('application').get('nokPhone').setErrors(null);
            } else {
                fg.get('person').get('application').get('nokPhone').setErrors({ 'incorrect': true });
            }
        } else {
            fg.get('person').get('application').get('middleNokPhone').setErrors(null);
            fg.get('person').get('application').get('middleNokPhone').setValidators(null);
            fg.get('person').get('application').get('nokPhone').setValidators([Validators.required, Validators.pattern('[0-9]\\d{5,15}')]);
            if (fg.get('person').get('application').get('nokPhone').value.length >= 5 && fg.get('person').get('application').get('nokPhone').value.length <= 15) {
                fg.get('person').get('application').get('nokPhone').setErrors(null);
            } else {
                fg.get('person').get('application').get('nokPhone').setErrors({ 'incorrect': true });
            }
        }
        fg.get('person').get('application').get('nokPhoneCode').valueChanges.subscribe(data => {
            fg.get('person').get('application').get('middleNokPhone').setValue('');
        });
    }

    endMessageMobileCheck(fg: FormGroup): ValidatorFn | any {

        const mobileCountryCode = fg.get('mobileCountryCode').value;
        const middleMobilePhoneNumber = fg.get('middleMobilePhoneNumber').value;
        if (mobileCountryCode === null || mobileCountryCode === '') {
            fg.get('mobileCountryCode').setErrors({ 'incorrect': true });
        } else if (mobileCountryCode === '+353') {
            fg.get('middleMobilePhoneNumber').setValidators([Validators.required]);
            if (middleMobilePhoneNumber === '083' || middleMobilePhoneNumber === '085' ||
                middleMobilePhoneNumber === '086' || middleMobilePhoneNumber === '087' || middleMobilePhoneNumber === '089') {
                fg.get('middleMobilePhoneNumber').setErrors(null);
            } else {
                fg.get('middleMobilePhoneNumber').setErrors({ 'incorrect': true });
            }
            fg.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{6}')]);
            if (fg.get('mobilePhoneNumber').value.length === 7) {
                fg.get('mobilePhoneNumber').setErrors(null);
            } else {
                fg.get('mobilePhoneNumber').setErrors({ 'incorrect': true });
            }
        } else if (mobileCountryCode === '+44') {
            fg.get('middleMobilePhoneNumber').setValidators([Validators.required]);
            if (middleMobilePhoneNumber === '073' || middleMobilePhoneNumber === '075' || middleMobilePhoneNumber === '076' ||
                middleMobilePhoneNumber === '077' || middleMobilePhoneNumber === '078' || middleMobilePhoneNumber === '079') {
                fg.get('middleMobilePhoneNumber').setErrors(null);
            } else {
                fg.get('middleMobilePhoneNumber').setErrors({ 'incorrect': true });
            }
            fg.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{7}')]);
            if (fg.get('mobilePhoneNumber').value.length === 8) {
                fg.get('mobilePhoneNumber').setErrors(null);
            } else {
                fg.get('mobilePhoneNumber').setErrors({ 'incorrect': true });
            }
        } else {
            fg.get('middleMobilePhoneNumber').setErrors(null);
            fg.get('middleMobilePhoneNumber').setValidators(null);
            fg.get('mobilePhoneNumber').setValidators([Validators.required, Validators.pattern('[0-9]\\d{5,15}')]);
            if (fg.get('mobilePhoneNumber').value.length >= 5 && fg.get('mobilePhoneNumber').value.length <= 15) {
                fg.get('mobilePhoneNumber').setErrors(null);
            } else {
                fg.get('mobilePhoneNumber').setErrors({ 'incorrect': true });
            }
        }
        fg.get('mobileCountryCode').valueChanges.subscribe(data => {
            fg.get('middleMobilePhoneNumber').setValue('');
        });
    }
}
